import { CognitiveRouteRecord } from '@/router/routes/types'

const routes = [
  {
    path: '/company',
    redirect: '/companies',
    name: 'Company Root',
    meta: {
      title: 'Company',
      requiredRoles: ['user'],
    },
  },
  {
    path: '/company/:company',
    component: () => import('@/pages/company/_id.vue'),
    name: 'Company',
    meta: {
      title: 'Description',
      requiredRoles: ['user'],
    },
    children: [
      {
        alias: '',
        path: 'description',
        component: () => import('@/pages/company/Description.vue'),
        meta: {
          title: 'Description',
          requiredRoles: ['user'],
        },
      },
      {
        alias: '',
        path: 'documents',
        component: () => import('@/pages/company/DocumentsPage.vue'),
        meta: {
          title: 'Documents',
          requiredRoles: ['user'],
        },
      },
      {
        path: 'financials',
        name: 'Company Model',
        component: () => import('@/pages/company/_model.vue'),
        meta: {
          title: 'Financials',
          requiredRoles: ['user'],
        },
        children: [
          {
            name: 'Custom Company Model',
            path: ':model/:version?',
            component: () => import('@/pages/company/_model.vue'),
            meta: {
              title: 'Financials',
              requiredRoles: ['user'],
            },
          },
        ],
      },
      {
        path: 'forecasting',
        name: 'Company Forecasting',
        meta: {
          title: 'Forecasting Home',
          requiredRoles: ['user'],
        },
        redirect: { name: 'Company Forecasting Home' },
        component: () => import('@/pages/PassThrough.vue'),
        children: [
          {
            name: 'Company Forecasting Home',
            path: 'home',
            component: () => import('@/components/company/forecasting/ForecastingHome.vue'),
            meta: {
              title: 'Forecasting Home',
              requiredRoles: ['user'],
            },
          },
          {
            name: 'Company Forecasting Model',
            path: ':model',
            component: () => import('@/pages/company/_model.vue'),
            props: true,
            meta: {
              title: 'Forecasting',
              requiredRoles: ['user'],
            },
          },
        ],
      },
      {
        path: 'instruments',
        meta: {
          title: 'Instruments',
          requiredRoles: ['user'],
        },
        component: () => import('@/pages/company/InstrumentsPage.vue'),
      },
      {
        path: 'deals',
        meta: {
          title: 'Deals',
          requiredRoles: ['user'],
          featureFlagRequired: 'CF-3925_HOST_ALL_DOCS',
        },
        component: () => import('@/pages/company/DealsPage.vue'),
      },
    ],
  },
] as const satisfies CognitiveRouteRecord[]

export default routes
